import { render, staticRenderFns } from "./collectDialog.vue?vue&type=template&id=93976a8e&scoped=true&"
import script from "./collectDialog.vue?vue&type=script&lang=js&"
export * from "./collectDialog.vue?vue&type=script&lang=js&"
import style0 from "./collectDialog.vue?vue&type=style&index=0&id=93976a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93976a8e",
  null
  
)

export default component.exports